import { CashAcceptorStatusCode } from "./CashAcceptorStatusCode";
import { ResultWrapper } from "./PostRobot";

export type CashStatusChangeListener = (result: ResultWrapper<CashAcceptorStatusCode>) => void;
export type TransactionChangedListener = (result: ResultWrapper<BusMessage<AddPaymentMessage | TransacitonCompleteMessage | any>>) => void;
export type CloseRequestListener = (result: ResultWrapper<ApplicationCloseReason>) => Promise<any>;

export class BusMessage<T> {
    EventData: T;
    EventID: BusEvent;
    EventStatus: BusEventStatus;
    ProcessID: string;
}

export enum BusEvent {
    TransactionProcessStarted = "GetProduct",
    TransactionAddPayment = "AddPayment",
    TransactionComplete = "TransactionComplete",
}

export enum BusEventStatus {
    Error = "Error",
    Success = "Success"
}

export interface AddPaymentMessage {
    AddedBanknote?: string;
    TotalAmount?: string;
}

export interface TransacitonCompleteMessage {
    customerAccount?: string;
    TransactionID?: string;
}

export enum ApplicationCloseReason {
    HomeButtonClick = "HomeButtonClickk",
    IdleTimer = "IdleTimer",
    KioskOutOfOrder = "KioskOutOfOrder",
    NoInternetConnection = "NoInternetConnection"
}
